module.exports = __webpack_public_path__ + "img/title.3ca53e4d.png";